import React, { useState } from "react";
import { useEffect} from 'react';
import { Button, Modal, Input } from "antd";
import CallIcon from "@mui/icons-material/Call";
import { Link } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Container } from "react-bootstrap";
import IconCity from "../../../assets/images/icon-city.png";
import LoginOtp from "./loginOtp";
import SignUpModal from "./signUpModal";
import FacebookIcon from '@mui/icons-material/Facebook';
// import { GoogleOutlined } from "@ant-design/icons";
import google_icon from "../../../assets/images/google_logo.png";
// import LocationCityIcon from "@mui/icons-material/LocationCity";

const LoginModal = (props) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  // const [set, testSet] = useState();

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  // useEffect(() => {
  //   // 👇️ use document.getElementById()
  //   const el = document.getElementById('my-element');
  //   testSet(el)
   

    
   
  // }, []);
  return (
    <div>
      <Link to="" onClick={showModal} >
        {props.login } 
      </Link>
      <Modal
        // className="login-modal-section "
        // title={props.title}
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        centered=" true"
        title={null}
        header={null}
        footer={null}
      >
        <Container className="main-login-section">
          <Row className="pt-1">
            <Col className="d-flex">
              <img src={IconCity} alt="city-icon" />
              {/* <LocationCityIcon  /> */}
              <p className="m-0 p-0  px-3 login-title ">Login</p>
            </Col>
          </Row>

          <div className="mb-3 login-input-wrap">
              <span className="input-icon ">
              <span className="input-icon ">
                <CallIcon className="path-phone-outline" />
              </span>
              </span>
              <Input
                placeholder="Enter mobile number / Email address"
                className=" p-3 px-5 mobile-input "
                required
                
              />
          </div>

          {/* <Row>
            <Col >
            <div className="login-or-wrap">
              <div className="login-hr"></div>
              <div className="login-or">Or</div>
              <div className="login-hr"></div>
            </div>
            </Col>
          </Row> */}

          {/* <Row className="mb-1 ">
            <Col>
            <div className="signup-input-wrap">

           
              <span className="at-rate-symbl input-icon ">
                @
              </span>
              <Input
                placeholder="Enter email address"
                className=" p-3 px-5 mobile-input "
              />
               </div>
            </Col>
          </Row> */}

          <Row className="mt-3">
            <Col>
              <div className="otp-number  ">
              {/* <span> Send a OTP to your enter number or email address</span> */}
              </div>
            </Col>
          </Row>

         

          <Row className="m-3">
            <Col>
            
              <div  id="my-element" className="d-flex flex-column justify-content-center align-items-center ">
                {/* <Button type="primary" className="proceed-btn  ">Procced</Button> */}
                <Button type="primary " className="proceed-btn">
                  <LoginOtp />
                </Button>
              </div>
            </Col>
          </Row>

          <div className=" mb-2 ">
            

              <div className="account-text">
                <p>
                  {" "}
                  Don’t have an account yet?  </p>
                  <span> <SignUpModal title="Sign Up " signup="SignUp"/></span>
               
              </div>
           
          </div>

          <Row>
            <Col className="px-0">
            <div className="login-or-wrap signin-or signin-or-wrap">
              <div className="signin-hr"></div>
              <div className="signin-or">Or Sign in with</div>
              <div className="signin-hr"></div>
            </div>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Button className="login-btn-wrap">
              {/* <GoogleOutlined  /> */}
              <img className="google-logo" src={google_icon} alt="google-icon"/>
              Google</Button>
            </Col>
            <Col md={6}>
            <Button className="login-btn-wrap fb-btn">
            <FacebookIcon className="fb" />
            Facebook</Button>
            </Col>
          </Row>
        </Container>
      </Modal>
    </div>
  );
};

export default LoginModal;
